import CryptoJS from 'crypto-js';

const secretKey = CryptoJS.enc.Hex.parse(process.env.REACT_APP_ENCRYPT_SECRET_KEY);
const iv = CryptoJS.enc.Hex.parse(+process.env.REACT_APP_IV);

const encrypt = (text) => {
  const cipherText = CryptoJS.AES.encrypt(text, secretKey, { iv }).toString();
  return cipherText;
};

const decrypt = (cipherText) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey, { iv });
  const plainText = bytes.toString(CryptoJS.enc.Utf8);
  return plainText;
};

const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey, { iv });
    const plainText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plainText);
  } catch (error) {
    throw new Error('Failed to decrypt response data');
  }
};

export { encrypt, decrypt, decryptData };
